export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_05.057dee25.jpg";